export default __webpack_public_path__ + "static/media/howto_map.24c97fac.jpg";